const transformTime = (time, twoNumbers) => {
  const transformedTime = twoNumbers ? `${time.slice(0, 5)} ${time.slice(9)}` : `${time.slice(0, 4)} ${time.slice(7)}`;

  return transformedTime;
};

export default transformTime;
